import { ISelectOption } from '@apps-common/types/form'

export const RMA_ROLE = 'radionetManagement.admin'
export const RMU_ROLE = 'radionetManagement.user'

export const MMA_ROLE = 'radionetMyMonitoring.admin'
export const MMU_ROLE = 'radionetMyMonitoring.user'

export const MY_MONITORING_ROLE_OPTION_USER = { label: 'User', value: 'user' }
export const MY_MONITORING_ROLE_OPTION_ADMIN = { label: 'Admin', value: 'admin' }

export const MY_MONITORING_ROLES_OPTIONS: ISelectOption[] = [MY_MONITORING_ROLE_OPTION_USER, MY_MONITORING_ROLE_OPTION_ADMIN]
